import { render, staticRenderFns } from "./payment_status.vue?vue&type=template&id=3881036b"
import script from "./payment_status.vue?vue&type=script&lang=js"
export * from "./payment_status.vue?vue&type=script&lang=js"
import style0 from "./payment_status.vue?vue&type=style&index=0&id=3881036b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports